import React from "react"
import { connect } from "react-redux"
import Root from "#/components/views/Root"
import { getIsLoggedIn, getLoadingIsLoggedIn } from "#/redux/reducers/application"
import {
  getAddress1,
  getAddress2,
  getCity,
  getDateOfBirth,
  getEmail,
  getFirstName,
  getLastName,
  getMemberState,
  getZip
} from "#/redux/reducers/userInfo"
import { fetchReduxData } from "#/redux/actions/loginActions"
import { ScrollToTop } from "../views/ScrollToTop"

// The signed-in member's carrot-app profile fields threaded into the consumer
// subscription funnel to prefill the details step. Carrot-app-native values
// (`state` is the 2-letter abbreviation, `dateOfBirth` is "YYYY-MM-DD"); each is
// undefined until user info loads (or when signed out).
type MemberProfile = {
  firstName?: string
  lastName?: string
  dateOfBirth?: string
  address1?: string
  address2?: string
  city?: string
  state?: string
  zip?: string
}

type RootContainerProps = {
  isLoggedIn: boolean
  loadingIsLoggedIn: boolean
  // The signed-in member's account email (redux `userInfo.email`), threaded into
  // the consumer subscription funnel so it can prefill/lock the details step.
  // Undefined until user info loads (or when signed out) — the funnel keeps the
  // email editable in that case.
  memberEmail?: string
  memberProfile: MemberProfile
  fetchReduxData: () => void
}

class InternalRootContainer extends React.Component<RootContainerProps> {
  componentDidMount() {
    this.props.fetchReduxData()
  }

  render() {
    const { isLoggedIn, loadingIsLoggedIn, memberEmail, memberProfile } = this.props
    return (
      <ScrollToTop>
        <Root
          // @ts-expect-error the withLDProvider HOC wrapping Root erases its prop types (props collapse to IntrinsicAttributes).
          loggedIn={isLoggedIn}
          loadingIsLoggedIn={loadingIsLoggedIn}
          email={memberEmail}
          memberProfile={memberProfile}
        />
      </ScrollToTop>
    )
  }
}

const mapStateToProps = (state: any) => ({
  isLoggedIn: getIsLoggedIn(state),
  loadingIsLoggedIn: getLoadingIsLoggedIn(state),
  memberEmail: getEmail(state) ?? undefined,
  memberProfile: {
    firstName: getFirstName(state) ?? undefined,
    lastName: getLastName(state) ?? undefined,
    dateOfBirth: getDateOfBirth(state) ?? undefined,
    address1: getAddress1(state) ?? undefined,
    address2: getAddress2(state) ?? undefined,
    city: getCity(state) ?? undefined,
    state: getMemberState(state) ?? undefined,
    zip: getZip(state) ?? undefined
  }
})

const RootContainer = connect(mapStateToProps, {
  fetchReduxData
})(InternalRootContainer)

export default RootContainer
